"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMoreState = exports.setFixedIndex = void 0;
var setMoreState = exports.setMoreState = function setMoreState(fixedIndex, loopIndex, slideCount, maxNumberOfDots) {
  var middleDot = Math.ceil(maxNumberOfDots / 2);
  if (slideCount <= maxNumberOfDots) {
    return false;
  }

  // first dot
  if (loopIndex <= fixedIndex - middleDot + 1 && fixedIndex >= middleDot) {
    return true;
  }

  // last dot
  if (loopIndex >= fixedIndex + middleDot - 1 && slideCount > fixedIndex + middleDot) {
    return true;
  }
  return false;
};
var setFixedIndex = exports.setFixedIndex = function setFixedIndex(index, slideCount, maxNumberOfDots) {
  var halfMaxNumberOfDots = maxNumberOfDots / 2;
  var fixedIndex = index;
  if (index < maxNumberOfDots / 2) {
    fixedIndex = maxNumberOfDots / 2;
  } else if (index > slideCount - halfMaxNumberOfDots) {
    fixedIndex = slideCount - halfMaxNumberOfDots;
  }
  if (slideCount < maxNumberOfDots) {
    fixedIndex = 0;
  }
  return Math.floor(fixedIndex);
};